export const HTML_ENTITIES = {
  BULLET: '\u2022', // •
};
